<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('news.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('news.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <ts-button outline color="info" @click.prevent="addNew">
            {{ $t('add_new') }}
          </ts-button>
          <div class="d-flex">
            <ts-input
              v-model="search"
              :placeholder="$t('news.search')"
              style="width: 250px;"
              class="inline-block"
            />
            <ts-button
              outline
              class="ml-2"
              v-tooltip="$t('filter')"
              @click.prevent="visible = true"
            >
              <i class="fa fa-filter"></i>
            </ts-button>
            <a-drawer
              :title="$t('filter')"
              placement="right"
              :closable="false"
              :visible="visible"
              @close="visible = false"
              :zIndex="1020"
              width="300px"
            >
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label>{{ $t('language') }}</label>
                    <a-select
                      @change="fetchData"
                      v-model="langId"
                      :options="languages"
                      class="ts-w-full"
                    ></a-select>
                  </div>
                </div>
              </div>
            </a-drawer>
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table :columns="columns" :records="resources" :loading="loading">
        <template v-slot="{ record }">
          <td>{{ record.title }}</td>
          <td>{{ record.short_description }}</td>
          <td class="text-center">
            <a
              href="#"
              v-tooltip="$t('edit')"
              class="text-primary mr-2"
              @click.prevent="edit(record)"
            >
              <i class="fas fa-edit"></i>
            </a>
            <a-popconfirm
              class="ts-cursor-pointer"
              placement="left"
              :ok-text="$t('yes')"
              :cancel-text="$t('no')"
              @confirm="deleteRecord(record)"
            >
              <template slot="title">
                <p>{{ $t('are_you_sure_to_delete') }}</p>
              </template>
              <i
                class="fas fa-circle-notch spin ml-2"
                v-if="record._deleting"
              ></i>
              <i class="fa fa-trash ml-2 text-red" v-else></i>
            </a-popconfirm>
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState, mapActions } from 'vuex'
export default {
  name: 'news',
  data() {
    return {
      languages: [],
      loading: false,
      visible: false
    }
  },
  created() {
    this.fetchLang()
    this.fetchData()
  },
  computed: {
    ...mapState('administrator/news', ['resources', 'pagination']),
    langId: {
      get() {
        return this.$store.state.administrator.news.lang_id
      },
      set(newValue) {
        this.$store.commit('administrator/news/SET_LANG', newValue)
      }
    },
    search: {
      get() {
        return this.$store.state.administrator.news.search
      },
      set(newValue) {
        this.$store.commit('administrator/news/SET_SEARCH', newValue)
        this.$store.commit('administrator/news/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        { name: this.$t('news.title') },
        { name: this.$t('news.shortDescription') },
        { name: this.$t('actions'), style: 'text-align:center; width: 1px;' }
      ]
    }
  },
  methods: {
    ...mapActions('administrator/news', ['destroy', 'getLang']),
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('administrator/news/fetch', { ...attributes })
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    addNew() {
      this.$router.push({ name: 'news-create' })
    },
    deleteRecord(record) {
      record._deleting = true
      this.destroy(record.new_id)
        .then(response => {
          this.$toasted.success(response.message)
          this.fetchData()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    edit(record) {
      this.$store.commit('administrator/news/SET_EDIT_DATA', record)
      this.$router.push({ name: 'news-edit', params: { id: record.new_id } })
    },
    fetchLang() {
      this.getLang()
        .then(response => {
          this.languages = response.data.map(el => ({
            value: el.lang_id,
            label: el.language_name
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('administrator/news/RESET_STATE')
    next()
  }
}
</script>
